import { createContext } from "preact";

export const Context = createContext();
